package services.auth.http

import it.neckar.rest.RestResponse
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface DeletedUserResponse : RestResponse<UserLoginName> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: UserLoginName) : DeletedUserResponse, RestResponse.GoodResponse<UserLoginName>

  @Serializable
  @SerialName("bad/Failed")
  data class Failed(val errorType: ErrorType) : DeletedUserResponse, RestResponse.BadResponse<UserLoginName> {
    enum class ErrorType {
      UserNotFound,
      FailToFetch,

      /**
       * The user is the replacement for deleted users and must stay.
       */
      ReplacementUserCannotBeDeleted,

      /**
       * The user is deleted, but the process state assignments could not be moved. Deleting the user again repeats the move.
       */
      ReassignmentFailed,
    }
  }

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: UserLoginName): DeletedUserResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(errorType: Failed.ErrorType): DeletedUserResponse = Failed(errorType)
  }
}

